define([
    'common/ui/view/svg/shape/index',
    'common/ui/view/svg/text/path',
    'victor'
], function(
    Shape,
    TextpathView,
    Victor
    ) {
    var DiamondShape = Shape.extend({
        tagName: 'path',
        initialize: function(params) {
            DiamondShape.__super__.initialize.call(this, params);
        },

        imageOffset: function() {
            var imageSize = this.imageSize();
            return {
                x: - imageSize / 2,
                y: - imageSize / 2
            };
        },

        render: function() {
            const mX = this._width / 2;
            const mY = this._height / 2;
            this.$el
                .attr('d', `M0,-${mY} L-${mX},0 L0,${mY} L${mX},0 Z`);

            return this;
        },

        createTextpath: function(params) {
            const mX = this._width / 2;
            const mY = this._height / 2;
            const mX4 = this._width / 8;
            const mY34 = this._height / 8 * 3;
            const path = `M-${mX},0 L-${mX4},-${mY34} Q0,-${mY} ${mX4},-${mY34} L${mX},0`;
            return new TextpathView({
                id: params.id,
                path: path,
                offset: '50%'
            });
        },

        getBottomRightPoints: function(params) {
            var interval = params.interval;
            var points = [];
            var l = Math.sqrt(this._width * this._width + this._height * this._height) / 2;
            var i = 0;

            while(true) {
                var point = {
                    x: this._width / 2 * (l - interval * (i + 1)) / l,
                    y: this._height / 2  * interval * (i + 1) / l
                };

                if(point.x < interval) {
                    break;
                }
                points.push(point);
                i++;
            }

            return points;
        },

        getBottomLeftPoints: function(params) {
            var interval = params.interval;
            var points = [];
            var l = Math.sqrt(this._width * this._width + this._height * this._height) / 2;
            var i = 0;

            while(true) {
                var point = {
                    x: - this._width / 2 * (l - interval * (i + 1)) / l,
                    y: this._height / 2  * interval * (i + 1) / l
                };

                if(point.x > - interval) {
                    break;
                }
                points.push(point);
                i++;
            }

            return points;
        },

        getBorderPoint: function(direction, offset) {
            var angle = (- direction.angleDeg() + 360) % 360;
            offset = offset ? offset : 0;
            var l = Math.sqrt(this._width * this._width + this._height * this._height);
            var height = this._height + offset * l / this._width * 2;
            var width = this._width + offset * l / this._height * 2;

            if(0 <= angle && angle < 90) {
                var t = 1 / (1 + Math.tan(angle / 180 * Math.PI) * this._width / this._height);
                return Victor.fromObject({
                    x: width / 2 * t,
                    y: - height / 2 * (1 - t)
                });
            } else if(90 <= angle && angle < 180) {
                var t = 1 / (1 - Math.tan(angle / 180 * Math.PI) * this._width / this._height);
                return Victor.fromObject({
                    x: - width / 2 * t,
                    y: - height / 2 * (1 - t)
                });
            } else if(180 <= angle && angle < 270) {
                var t = 1 / (1 + Math.tan(angle / 180 * Math.PI) * this._width / this._height);
                return Victor.fromObject({
                    x: - width / 2 * t,
                    y: height / 2 * (1 - t)
                });
            } else if(270 <= angle && angle < 360) {
                var t = 1 / (1 - Math.tan(angle / 180 * Math.PI) * this._width / this._height);
                return Victor.fromObject({
                    x: width / 2 * t,
                    y: height / 2 * (1 - t)
                });
            }
        },

        getBorderTangent: function(direction, offset) {
            var angle = (- direction.angleDeg() + 360) % 360;
            offset = offset ? offset : 0;
            var l = Math.sqrt(this._width * this._width + this._height * this._height);
            var height = this._height + offset * l / this._width * 2;
            var width = this._width + offset * l / this._height * 2;

            if(0 <= angle && angle <= 5 || 355 <= angle) {
                return Victor.fromObject({
                    x: 1,
                    y: 0
                }).norm();
            } else if(85 <= angle && angle < 95) {
                return Victor.fromObject({
                    x: 0,
                    y: -1
                }).norm();
            } else if(175 <= angle && angle < 185) {
                return Victor.fromObject({
                    x: -1,
                    y: 0
                }).norm();
            } else if(265 <= angle && angle < 275) {
                return Victor.fromObject({
                    x: 0,
                    y: 1
                }).norm();
            }

            if(0 <= angle && angle < 90) {
                return Victor.fromObject({
                    x: height,
                    y: - width
                }).norm();
            } else if(90 <= angle && angle < 180) {
                return Victor.fromObject({
                    x: - height,
                    y: - width
                }).norm();
            } else if(180 <= angle && angle < 270) {
                return Victor.fromObject({
                    x: - height,
                    y: width
                }).norm();
            } else if(270 <= angle && angle < 360) {
                return Victor.fromObject({
                    x: height,
                    y: width
                }).norm();
            }
        }
    }, {
        type: 'diamond'
    });

    return DiamondShape;
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/shape/diamond.js